export const PINYIN_KEYBOARD_LAYOUTS = [
  "qwerty",
  "xiaohe",
  "ziranma",
  "sogou",
  "weiruan",
  "pinyin-jiajia",
  "changyong",
] as const;

export type PinyinKeyboardLayout = (typeof PINYIN_KEYBOARD_LAYOUTS)[number];

export const PINYIN_KEYBOARD_LAYOUT_LABELS: Record<PinyinKeyboardLayout, string> = {
  changyong: "Changyong",
  "pinyin-jiajia": "Pinyin Jiajia",
  qwerty: "QWERTY",
  sogou: "Sogou",
  weiruan: "Weiruan",
  xiaohe: "Xiaohe",
  ziranma: "Ziranma",
};

export type ShuangpinKeyboardKey =
  | "Q"
  | "W"
  | "E"
  | "R"
  | "T"
  | "Y"
  | "U"
  | "I"
  | "O"
  | "P"
  | "A"
  | "S"
  | "D"
  | "F"
  | "G"
  | "H"
  | "J"
  | "K"
  | "L"
  | ";"
  | "Z"
  | "X"
  | "C"
  | "V"
  | "B"
  | "N"
  | "M";

export type ShuangpinKeyboardLayout = {
  readonly layout: Readonly<Record<ShuangpinKeyboardKey, readonly string[]>>;
  readonly name: string;
};

export const SHUANGPIN_KEYBOARD_LAYOUTS = [
  {
    layout: {
      ";": [],
      A: ["zh", "a"],
      B: ["ou"],
      C: ["in", "uai"],
      D: ["ia", "ua"],
      E: ["ch", "e"],
      F: ["en"],
      G: ["eng"],
      H: ["ang"],
      I: ["i"],
      J: ["an"],
      K: ["ao"],
      L: ["ai"],
      M: ["ue", "ui"],
      N: ["un"],
      O: ["uo", "o"],
      P: ["uan"],
      Q: ["ei"],
      R: ["er", "iu"],
      S: ["iong", "ong"],
      T: ["iang", "uang"],
      U: ["u"],
      V: ["sh", "ü", "üe"],
      W: ["ian"],
      X: ["ie"],
      Y: ["ing"],
      Z: ["iao"],
    },
    name: "default",
  },
  {
    layout: {
      ";": ["ing"],
      A: ["a"],
      B: ["ou"],
      C: ["iao"],
      D: ["uang", "iang"],
      E: ["e"],
      F: ["en"],
      G: ["eng"],
      H: ["ang"],
      I: ["ch", "i"],
      J: ["an"],
      K: ["ao"],
      L: ["ai"],
      M: ["ian"],
      N: ["in"],
      O: ["uo", "o"],
      P: ["un"],
      Q: ["iu"],
      R: ["er", "uan"],
      S: ["iong", "ong"],
      T: ["ue", "üe"],
      U: ["sh", "u"],
      V: ["zh", "ui"],
      W: ["ia", "ua"],
      X: ["ie"],
      Y: ["uai", "ü"],
      Z: ["ei"],
    },
    name: "sogou",
  },
  {
    layout: {
      ";": [],
      A: ["a"],
      B: ["ia", "ua"],
      C: ["uan"],
      D: ["ao"],
      E: ["e"],
      F: ["an"],
      G: ["ang"],
      H: ["iang", "uang"],
      I: ["sh", "i"],
      J: ["ian"],
      K: ["iao"],
      L: ["in"],
      M: ["ie"],
      N: ["iu"],
      O: ["uo", "o"],
      P: ["ou"],
      Q: ["er", "ing"],
      R: ["en"],
      S: ["ai"],
      T: ["eng"],
      U: ["ch", "u"],
      V: ["zh", "ü", "ui"],
      W: ["ei"],
      X: ["uai", "ue"],
      Y: ["iong", "ong"],
      Z: ["un"],
    },
    name: "pinyin-jiajia",
  },
  {
    layout: {
      ";": ["ing"],
      A: ["a"],
      B: ["ou"],
      C: ["iao"],
      D: ["uang", "iang"],
      E: ["e"],
      F: ["en"],
      G: ["eng"],
      H: ["ang"],
      I: ["ch", "i"],
      J: ["an"],
      K: ["ao"],
      L: ["ai"],
      M: ["ian"],
      N: ["in"],
      O: ["uo", "o"],
      P: ["un"],
      Q: ["iu"],
      R: ["er", "uan"],
      S: ["iong", "ong"],
      T: ["ue"],
      U: ["sh", "u"],
      V: ["zh", "üe", "ui"],
      W: ["ia", "ua"],
      X: ["ie"],
      Y: ["uai", "ü"],
      Z: ["ei"],
    },
    name: "weiruan",
  },
  {
    layout: {
      ";": [],
      A: ["a"],
      B: ["in"],
      C: ["ao"],
      D: ["ai"],
      E: ["e"],
      F: ["en"],
      G: ["eng"],
      H: ["ang"],
      I: ["ch", "i"],
      J: ["an"],
      K: ["ing", "uai"],
      L: ["iang", "uang"],
      M: ["ian"],
      N: ["iao"],
      O: ["uo", "o"],
      P: ["ie"],
      Q: ["iu"],
      R: ["uan"],
      S: ["iong", "ong"],
      T: ["üe", "ue"],
      U: ["sh", "u"],
      V: ["zh", "ü", "ui"],
      W: ["ei"],
      X: ["ia", "ua"],
      Y: ["un"],
      Z: ["ou"],
    },
    name: "xiaohe",
  },
  {
    layout: {
      ";": [],
      A: ["a"],
      B: ["ou"],
      C: ["iao"],
      D: ["uang", "iang"],
      E: ["e"],
      F: ["en"],
      G: ["eng"],
      H: ["ang"],
      I: ["ch", "i"],
      J: ["an"],
      K: ["ao"],
      L: ["ai"],
      M: ["ian"],
      N: ["in"],
      O: ["o", "uo"],
      P: ["un"],
      Q: ["iu"],
      R: ["uan"],
      S: ["ong", "iong"],
      T: ["ue", "üe"],
      U: ["sh", "u"],
      V: ["zh", "ü", "ui"],
      W: ["ia", "ua"],
      X: ["ie"],
      Y: ["ing", "uai"],
      Z: ["ei"],
    },
    name: "changyong",
  },
] as const satisfies readonly ShuangpinKeyboardLayout[];
